export default {
      id: "mail-footer-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#mail-footer",
      toString: function () {
        return this.url;
      }
    }